import PropTypes, { number, string } from 'prop-types';

const edocketSummaryType = PropTypes.shape({
    DraftDocketStatus: string,
    ClientName: string.isRequired,
    SiteName: string.isRequired,
    SiteForeman: string,
    FPHJobNumber: number.isRequired,
    DocketDate: string.isRequired,
    PurchaseOrderNumber: string.isRequired,
    SupplierTradingName: string.isRequired,
    OperatorName: string.isRequired,
    EquipmentUsed: string.isRequired,
    JobType: string.isRequired,
    eDocketNumber: string.isRequired
});

const edocketObjectType = PropTypes.shape({
    EquipmentItems: PropTypes.array.isRequired,
    FileItems: PropTypes.array,
    DocketQueryInfo: PropTypes.object,
    HistoryItems: PropTypes.array.isRequired,
    LoadItems: PropTypes.array.isRequired,
    TollItems: PropTypes.array,
    WaitingTimeItem: PropTypes.object,
    Summary: edocketSummaryType
});

export default edocketObjectType;

export { edocketSummaryType, edocketObjectType };

